import React from "react"
import { ThemeContext } from "../theme/context"
import { Icon } from "@chakra-ui/react"

const Logo = () => {
  return (
    <ThemeContext.Consumer>
      {({ brand, presets }) => (
        <Icon
          boxSize="42px"
          float="left"
          mr={2}
          viewBox="0 0 512 512"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m349.946 53.88c5.926 5.926 11.532 11.985 16.768 18.12h.283c10.718 0 21.252 1.185 31.457 3.489-18.259-45.254-47.265-83.863-74.606-73.911-7.795 2.837-13.155 8.786-16.487 16.916 18.404 12.309 33.7 26.502 42.331 35.134z"
            fill={presets(brand)[400]}
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m67.708 295.084c-23.915-13.807-52.256-9.491-63.301 9.641-11.046 19.132-.613 45.834 23.301 59.641 3.239 1.87 6.883 3.587 10.78 5.116 5.996-26.134 16.073-51.052 29.922-73.979-.233-.139-.468-.284-.702-.419z"
            fill={presets(brand)[500]}
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m512 207c.001-3.978-1.58-7.793-4.393-10.607l-61.716-61.716c-21.072-21.072-49.089-32.677-78.893-32.677-4.362.001-8.852.396-13.69 1.188-7.26-9.625-15.636-19.156-24.572-28.091l-.257-.257c-36.957-36.957-84.086-64.408-106.067-42.427s5.47 69.11 42.427 106.067l.257.257c7.016 7.016 14.399 13.688 21.906 19.745-3.305 9.241-5.002 18.82-5.002 28.518 0 5.077.45 10.095 1.344 15.029-58.735.927-113.808 24.237-155.444 65.872-42.496 42.497-65.9 98.999-65.9 159.099 0 22.704 8.841 44.05 24.895 60.104 16.055 16.054 37.401 24.896 60.105 24.896l145-.001v-20c0-22.088-17.903-39.994-39.99-40h-5.01c-8.284 0-15-6.716-15-15 0-17.29-4.178-74.539-57.942-85.291-8.123-1.625-13.392-9.527-11.767-17.65 1.625-8.125 9.527-13.391 17.65-11.768 27.175 5.436 49.157 20.649 63.572 43.997 9.888 16.017 15.959 35.285 17.847 56.357 34.188 4.596 60.64 33.939 60.64 69.356v20h145c8.284 0 15-6.716 15-15v-5c0-22.088-17.903-39.994-39.99-40h-50.01c-8.284 0-15-6.716-15-15s6.716-15 15-15h37.629c18.402-47.909 24.452-99.158 17.719-150.001 35.683-.187 64.653-29.275 64.652-64.999zm-110-10c-8.284 0-15-6.716-15-15s6.716-15 15-15 15 6.716 15 15-6.716 15-15 15z"
            fill={presets(brand)[300]}
          />
          {/* <path
            xmlns="http://www.w3.org/2000/svg"
            d="m86.166 124.462c0 39.165 17.458 76.823 47.897 103.318l106.937 93.081v-14.434c0-8.284 6.716-15 15-15s15 6.716 15 15v14.451l106.944-93.097c30.435-26.494 47.89-64.15 47.89-103.312v-121.163c-.772-.619-1.609-1.17-2.508-1.635-4.985-2.574-10.993-2.15-15.567 1.1l-68.026 48.323c-26.866-8.886-54.993-13.386-83.733-13.386-29.165 0-57.684 4.63-84.899 13.774l-66.713-48.606c-4.561-3.323-10.603-3.804-15.634-1.246-.929.473-1.794 1.036-2.588 1.673zm209.904 58.778c.635-6.246 5.2-11.53 11.283-13.072 6.049-1.534 12.671 1.004 16.117 6.213 3.465 5.236 3.312 12.202-.42 17.261-3.721 5.044-10.413 7.232-16.4 5.419-6.744-2.044-11.294-8.793-10.58-15.821zm-110 0c.634-6.236 5.198-11.543 11.281-13.072 6.059-1.524 12.659.999 16.119 6.213 3.472 5.232 3.309 12.205-.42 17.261-3.721 5.044-10.423 7.236-16.41 5.419-6.839-2.077-11.146-8.773-10.57-15.821z"
            fill={presets(brand)[400]}
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m455.834 114.557v9.91c0 47.843-21.211 93.746-58.193 125.939l-131.782 114.72c-2.823 2.458-6.336 3.687-9.849 3.687s-7.025-1.229-9.848-3.686l-116.346-101.27c-2.717 25.259-12.831 49.383-29.159 69.08-18.737 22.603-44.765 38.395-73.399 44.576 12.183 23.047 28.286 44.332 47.982 63.097 48.322 46.036 112.516 71.39 180.76 71.39s132.439-25.354 180.759-71.391c48.52-46.226 75.241-107.742 75.241-173.217 0-55.89-20.111-109.756-56.166-152.835z"
            fill={presets(brand)[400]}
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m20.016 348.388c45.899-9.456 79.395-49.617 80.492-95.996h-85.508c-8.284 0-15 6.716-15 15 0 28.754 5.157 56.744 15.047 83.012 1.484-.937 3.148-1.641 4.969-2.016z"
            fill={presets(brand)[600]}
          /> */}
          {/* <path
            d="M759 584L673.5 532L799.5 458L885 509L759 584Z"
            fill={presets(brand)[600]}
          />
          <path
            d="M443 400.5V252.5L218.5 384L347 456.5L443 400.5Z"
            fill={presets(brand)[400]}
          />
          <path
            d="M3.5 407L93 457.5L220.5 384.5L127.5 331L3.5 407Z"
            fill={presets(brand)[600]}
          />
          <path
            d="M548 460L443 400.5V252.5L675 385.5L548 460Z"
            fill={presets(brand)[600]}
          />
          <path
            d="M443 1.5V147L765 335L888 260.5L443 1.5Z"
            fill={presets(brand)[600]}
          />
          <path
            d="M91 456.5L448.5 665.5V518.5L219.5 383.5L91 456.5Z"
            fill={presets(brand)[600]}
          />
          <path
            d="M219 531.5L92 456L219 384L346.5 456L219 531.5Z"
            fill={presets(brand)[400]}
          />
          <path
            d="M2 656.5L449 916.5V769L131 582L2 656.5Z"
            fill={presets(brand)[600]}
          />
          <path
            d="M221.986 529.876L1.99998 656.5L0.999966 510L92.9791 455.021L221.986 529.876Z"
            fill={presets(brand)[400]}
          />
          <path
            d="M889 662.123L449 916.5L448 768.86L885.005 509L889 662.123Z"
            fill={presets(brand)[400]}
          />
          <path
            d="M448.5 665.5V518.5L888 260.5V406.5L448.5 665.5Z"
            fill={presets(brand)[400]}
          />
          <path d="M0 259L3.5 407L443 146.5V0.5L0 259Z" fill={presets(brand)[400]} /> */}
        </Icon>
      )}
    </ThemeContext.Consumer>
  )
}

export default Logo
